import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as BsIcons from "react-icons/bs";
import "./table.css";
import { slugify } from "../utils/helperFunctions";
import { useSelector } from "react-redux";
import { FaPencilAlt, FaTrashAlt, FaEye } from "react-icons/fa";

const DashboardTable = ({ exhibits, superUser, onRequestDelete, onReview }) => {
  return (
    <div className="table-container" role="table">
      <div className="flex-table header" role="rowgroup">
        <div className="flex-row" role="columnheader">
          Created
        </div>
        <div className="flex-row first" role="columnheader">
          Exhibits
        </div>
        <div className="flex-row" role="columnheader">
          Signed
        </div>
        <div className="flex-row" role="columnheader">
          Status
        </div>
      </div>
      {exhibits?.map((exhibit, index) => {
        const url = `${slugify(exhibit.companyName)}-${slugify(exhibit.id)}`;

        // Build a cache-busted PDF href from the saved Storage URL
        const version =
          exhibit?.updatedAt?.toMillis?.() ??
          (exhibit?.updatedAt?.seconds
            ? exhibit.updatedAt.seconds * 1000
            : exhibit?.updatedAt) ??
          Date.now();

        const pdfHref = exhibit?.pdfURL
          ? `${exhibit.pdfURL}${
              exhibit.pdfURL.includes("?") ? "&" : "?"
            }v=${encodeURIComponent(version)}`
          : null;

        return (
          <div
            key={index}
            className={
              index % 2 !== 0
                ? "flex-table row even-row"
                : "flex-table row odd-row"
            }
            role="rowgroup"
          >
            <div className="flex-row" role="cell">
              <div className="applicant-container">
                <p>{`${exhibit.createdDate}`}</p>
              </div>
            </div>

            <div className="flex-row first" role="cell">
              <div className="first-cell-container">
                <p className="table-exhibit-container">
                  {`ComplyOffice - ${exhibit.serviceProvider}`}
                </p>

                <div className="table-btn-container">
                  {/* VIEW → go to /review-… and hand off the fresh pdfHref via state */}
                  <Link
                    to={`/review-${url}`}
                    className="posted-btn view-exhibit-button"
                    state={{
                      showSubmit: false,
                      pdfHref,
                      exhibitId: exhibit.id,
                    }}
                    onClick={() => onReview?.(exhibit.id)}
                    title={pdfHref ? "View PDF" : "No PDF available yet"}
                    aria-label="View PDF"
                  >
                    <FaEye />
                  </Link>

                  {exhibit.status !== "Submitted" && (
                    <Link
                      to={`/edit-${url}`}
                      className="posted-btn edit-exhibit-button"
                      state={{ status: exhibit.status }}
                    >
                      <FaPencilAlt />
                    </Link>
                  )}

                  <button
                    type="button"
                    className="posted-btn remove-exhibit-button"
                    onClick={(e) => onRequestDelete(e, exhibit.id)}
                    aria-label="Delete exhibit"
                    title="Delete exhibit"
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              </div>
            </div>

            <div className="flex-row" role="cell">
              <div className="applicant-container">
                <p>
                  {exhibit.status === "Submitted" && !!exhibit.signDate
                    ? exhibit.signDate
                    : "Not Signed"}
                </p>
              </div>
            </div>

            <div className="flex-row" role="cell">
              <div className="applicant-container">
                <p>{exhibit.status}</p>
              </div>
            </div>
          </div>
        );
      })}

      <div className="table-row-a"></div>
    </div>
  );
};

export default DashboardTable;
